/**
 * Provides a method to fetch the data for the Top Lists (e.g., "Top
 * month income") displayed in the overview.
 *
 * @param {string[]} keyFigureIds - Each top list displays values of a
 * key figure which must be fetched.
 * @param {KeyFigurePresetService} keyFigurePresetService -
 * @param {KeyFigureResultService} keyFigureResultService - .
 */
export default class TopListsService {
	constructor({
		keyFigureIds,
		keyFigurePresetService,
		keyFigureResultService,
	}) {
		this._keyFigureIds = keyFigureIds;
		this._keyFigurePresetService = keyFigurePresetService;
		this._keyFigureResultService = keyFigureResultService;
	}

	fetch({ period, callback }) {
		this._keyFigurePresetService
			.getVisibleKeyFigures()
			.then(() =>
				this._keyFigureResultService.get({
					keyFigureIds: this._keyFigureIds,
					periodType: period.getPeriodType(),
				}),
			)
			.then((result) =>
				callback(
					period,
					this._createTopListData({
						result,
						keyFigureIds: this._keyFigureIds,
					}),
				),
			);
	}

	_createTopListData({ result, keyFigureIds }) {
		return keyFigureIds.map((keyFigureId) =>
			this._createTopListDataForKeyFigureId({ result, keyFigureId }),
		);
	}

	_createTopListDataForKeyFigureId({ result, keyFigureId }) {
		const keyFigure = result.getKeyFigureById(keyFigureId);
		const values = result.getValuesForKeyFigure(keyFigure);

		return { keyFigureId, keyFigure, values };
	}
}
